import { Pipe } from '@angular/core';

@Pipe({ standalone: false, name: 'datedisp' })
export class DateDisplayPipe {
	transform(value: any, format: string) {
		if (value === null) return 'null';
		if (typeof value === 'string') value = new Date(value);
		else if (
			typeof value === 'object' &&
			value !== null &&
			(typeof value.localValue !== 'undefined' || typeof value.LocalValue !== 'undefined')
		) {
			value = new DateDisplay(value).ZonedAsUTC();
		}

		return value.format(format);
	}
}
